// NavStore.ts
import { makeAutoObservable, observable } from "mobx";

export enum ProjectNavTypeEnum {
  "DEFAULT",
  "ALL",
  "PRIVTE",
}

export interface IProjectItem {
  id?: number;
  name: string;
  type?: ProjectNavTypeEnum;
  memberIds: string[];
  owner_name?: string;
  owner_uuid?: string;
}

class NavStore {
  private projectList: IProjectItem[] = observable([]);
  private projectId: number = null;

  constructor() {
    makeAutoObservable(this);
  }

  getProjectList() {
    // console.log("projectList", this.projectList);
    return this.projectList;
  }

  setProjectList(navList: IProjectItem[]) {
    console.log("setProjectList", navList);

    this.projectList = navList;
  }

  getProjectId() {
    return this.projectId;
  }

  setProjectId(id: number) {
    this.projectId = id;
  }
}

const navStore = new NavStore();

export default navStore;
